var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1080FF",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66406 11.3709C7.66406 9.32837 9.35593 7.66504 11.4345 7.66504H15.5688C17.6431 7.66504 19.3307 9.32337 19.3307 11.3625V20.6259C19.3307 22.6692 17.6389 24.3317 15.5594 24.3317H11.4269C9.35169 24.3317 7.66406 22.6734 7.66406 20.6342V19.8509V11.3709Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1451 15.5431L21.7736 13.1189C21.5285 12.8689 21.1341 12.8689 20.8898 13.1206C20.6463 13.3723 20.6471 13.7781 20.8914 14.0281L22.1908 15.3556H20.945H13.9531C13.6081 15.3556 13.3281 15.6431 13.3281 15.9973C13.3281 16.3523 13.6081 16.6389 13.9531 16.6389H22.1908L20.8914 17.9664C20.6471 18.2164 20.6463 18.6223 20.8898 18.8739C21.0123 18.9998 21.1722 19.0631 21.3329 19.0631C21.492 19.0631 21.6519 18.9998 21.7736 18.8756L24.1451 16.4523C24.2628 16.3314 24.3293 16.1681 24.3293 15.9973C24.3293 15.8273 24.2628 15.6639 24.1451 15.5431Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage4);
export default __webpack_public_path__ + "static/media/Image4.c066799104c401f6322abce287abc0e7.svg";
export { ForwardRef as ReactComponent };